<div class="content-header">
  <div class="top">
    @if(this.topSectionDataChip()) {
      <app-data-chip
        [label]="this.topSectionDataChip()?.label"
        [values]="this.topSectionDataChip()?.values"
        [links]="this.topSectionDataChip()?.links"
        [showCopyButton]="this.topSectionDataChip()?.showCopyButton"
        [leftIcons]="this.topSectionDataChip()?.leftIcons"
        [separateMultipleValues]="this.topSectionDataChip()?.separateMultipleValues"
      >
      </app-data-chip>
    }

    @for (pill of topSectionPills(); track $index) {
        @switch (pill.pillType) {
            @case(PillTypes.policy){
                <app-ui-severity-pill [score]="pill.pillInput"></app-ui-severity-pill>

            }
          @case (PillTypes.severity) {
            <app-ui-severity-pill [score]="pill.pillInput"></app-ui-severity-pill>
          }
          @case (PillTypes.status) {
            <app-ui-status-pill-typed [pillStatus]="pill.pillInput.pillStatus" [pillType]="pill.pillInput.pillType">
            </app-ui-status-pill-typed>
          }
        }
    }
  </div>
  <div class="title">
    <app-heading [text]="title()" [level]="'h2'"></app-heading>
    @if (pipedTitle()) {
      <app-heading [text]="pipedTitle()" [level]="'h2-regular'" class="piped-title"></app-heading>
    }
  </div>
  <div class="bottom">
    <div class="bottom-part">
      @for (dataChip of bottomSectionDataChipsTop(); track $index){
        <app-data-chip
          [label]="dataChip.label"
          [values]="dataChip.values"
          [links]="dataChip.links"
          [showCopyButton]="dataChip.showCopyButton"
          [leftIcons]="dataChip.leftIcons"
          [rightIcon]="dataChip.rightIcon"
          [separateMultipleValues]="dataChip.separateMultipleValues"
        >
        </app-data-chip>
      }
      @if (bottomSourceDestination()) {
        <div class="source-destination">
          <app-data-chip
            [label]="bottomSourceDestination()?.source?.label"
            [values]="bottomSourceDestination()?.source?.values"
            [links]="bottomSourceDestination()?.source?.links"
            [showCopyButton]="bottomSourceDestination()?.source?.showCopyButton"
            [leftIcons]="bottomSourceDestination()?.source?.leftIcons"
            [rightIcon]="bottomSourceDestination()?.source?.rightIcon"
            [separateMultipleValues]="bottomSourceDestination()?.source?.separateMultipleValues"
          >
          </app-data-chip>

          <app-icon [svgIcon]="IconsEnum.arrow_right"></app-icon>

          <app-data-chip
            [label]="bottomSourceDestination()?.destination?.label"
            [values]="bottomSourceDestination()?.destination?.values"
            [links]="bottomSourceDestination()?.destination?.links"
            [showCopyButton]="bottomSourceDestination()?.destination?.showCopyButton"
            [leftIcons]="bottomSourceDestination()?.destination?.leftIcons"
            [rightIcon]="bottomSourceDestination()?.destination?.rightIcon"
            [separateMultipleValues]="bottomSourceDestination()?.destination?.separateMultipleValues"
          >
          </app-data-chip>
        </div>
      }
    </div>
    <div class="bottom-part">
      @for (dataChip of bottomSectionDataChipsBottom(); track $index){
        <app-data-chip
          [label]="dataChip.label"
          [values]="dataChip.values"
          [links]="dataChip.links"
          [showCopyButton]="dataChip.showCopyButton"
          [leftIcons]="dataChip.leftIcons"
          [rightIcon]="dataChip.rightIcon"
          [separateMultipleValues]="dataChip?.separateMultipleValues"
        >
        </app-data-chip>
      }
    </div>
    @if (bottomSectionKpiDrawers() && bottomSectionKpiDrawers()!.length > 0) {
      <div class="bottom-part kpi-drawers">
        @for (kpiDrawer of bottomSectionKpiDrawers(); track $index){
          <app-kpi-drawer
            [icon]="kpiDrawer.icon"
            [label]="kpiDrawer.label"
            [infoTooltip]="kpiDrawer.infoTooltip"
            [value]="kpiDrawer.value"
            [subValue]="kpiDrawer.subValue"
            [progressBarType]="kpiDrawer.progressBarType"
            [progressBarValue]="kpiDrawer.progressBarValue"
            [vprScore]="kpiDrawer.vprScore"
            [riskScore]="kpiDrawer.riskScore"
            [criticality]="kpiDrawer.criticality"
            [stackedBarSegments]="kpiDrawer.stackedBarSegments"
          >
          </app-kpi-drawer>
        }
      </div>
    }
  </div>
</div>
